<si-dashboard-card
    [heading]="heading() | translate"
    class="[&]:!bg-deep-blue-850 [&>*]:!bg-deep-blue-850 [&>*>*]:!bg-deep-blue-850 [&]:!overflow-visible [&>*]:!overflow-visible [&>*>*]:!overflow-visible"
>
    <ng-container body>
        <div class="flex flex-col gap-8 !p-4">
            <ng-content />
        </div>
    </ng-container>
</si-dashboard-card>
